module.exports = __webpack_public_path__ + "media/icons/delete_all@2x-66cb886c.png";